import { Component, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { CentralService } from "../servicios/central.service";

@Component({
  selector: "app-portada",
  templateUrl: "./gestionpiensos.component.html",
  styleUrls: ["./gestionpiensos.component.css"],
})
export class GestionPiensos implements OnInit {
  marcaActual: any = null;

  constructor(private servicioCentral: CentralService) {}

  ngOnInit(): void {
    //console.log("GestorPiensos - ngOnInit");
  }

  nuevaMarca() {
    this.marcaActual = {
      ttcodmar: 0, // 0 = nueva marca
      ttdesmar: "",
      tipos: [{ ttcodtip: 0, ttdestip: "" }],
    };
  }

  // Añadir un nuevo tipo a la marca actual
  agregarTipo() {
    this.marcaActual.tipos.push({ ttcodtip: 0, ttdestip: "" });
  }

  // Eliminar tipo
  eliminarTipo(index: number) {
    this.marcaActual.tipos.splice(index, 1);
  }

  // Cancelar
  cancelar() {
    this.marcaActual = null;
  }

  guardarMarca() {
    const datos = this.marcaActual.tipos.map((tipo: any) => ({
      ttcodmar: this.marcaActual.ttcodmar,
      ttdesmar: this.marcaActual.ttdesmar,
      ttcodtip: tipo.ttcodtip,
      ttdestip: tipo.ttdestip,
    }));

    // modo = 0 → grabar
    this.servicioCentral.crudPiensos(datos, 0).subscribe({
      next: (res) => {
        //console.log("Guardado OK", res);
        alert("Marca guardada correctamente");
        this.marcaActual = null;
      },
      error: (err) => {
        console.error("Error al guardar", err);
        alert("Error al guardar la marca");
      },
    });
  }
}
